<template>
	<div class="link-tabs" :style="styles" :class="classes">
		<link-scroll :scroll-y="false" :scroll-x="true" v-if="!hideHeader" fitHeight>
			<div class="link-tabs-header">
				<div class="link-tabs-header-item"
					 v-for="(item,index) in items"
					 :key="index"
					 :class="{'link-tabs-header-item-active':index === currentValue}"
					 @click="_click(item,index)">
					<span>{{item.title}}</span>
					<link-icon icon="icon-minus-circle-fill" class="link-tabs-close" @click.stop="$emit('close',{item,index})" v-if="closeButton"/>
				</div>
				<div class="link-tabs-header-item link-tabs-header-item-new-button" v-if="newButton" @click.stop="$emit('new')">
					<link-icon icon="icon-plus"/>
				</div>
			</div>
		</link-scroll>
		<div class="link-tabs-body">
			<slot></slot>
		</div>
	</div>
</template>

<script>

	export default {
		name: "link-tabs",
		props: {
			value: {type: Number,},
			initialized: {type: Boolean},
			height: {},
			closeButton: {type: Boolean},
			newButton: {type: Boolean},
			hideHeader: {type: Boolean},
			fitHeight: {type: Boolean},
			fitPadding: {type: Boolean},		// 是否需要加内边距（上边距）不至于内部显示过于太挤
			id: {type: String},
		},
		watch: {
			id(val) {
				this.openById(val)
			},
			value(val) {
				this.currentValue !== val && (this.currentValue = val)
			},
			currentValue(val) {
				this.$emit('input', val)
				this.update()
				this.$nextTick(() => {
					const id = this.items[val].id
					this.$emit('change', {tab: this.items[val], index: val, id})
					this.$emit('update:id', id)
				})
			},
		},
		data() {
			return {
				currentValue: null,
				items: [],
			}
		},
		computed: {
			styles() {
				const styles = {}
				this.height !== null && (styles.height = this.$lv.$utils.unit(this.height))
				return styles
			},
			classes() {
				return [
					{
						'link-tabs-fit-height': this.fitHeight,
						'link-tabs-fit-height-padding': this.fitPadding
					}
				]
			},
		},
		methods: {
			openById(id) {
				const data = this.$lv.$utils.findOne(this.items, i => i.id === id, true)
				if (!!data) {
					this._click(data.item, data.index)
				} else {
					console.log(`无法找到id：${id}`, this.items)
				}
			},
			update() {
				this.items.forEach((item, index) => {
					const show = index === this.currentValue
					const next = () => item.show = show
					if (show && !item.currentInitialized) {
						item.currentInitialized = true
						this.$nextTick(next)
					} else {
						next()
					}
				})
			},
			_addItem(item) {
				this.items.push(item)
				!!this.initialized && (!item.currentInitialized) && (item.currentInitialized = this.initialized)
			},
			_removeItem(item) {
				this.items.splice(this.items.indexOf(item), 1)
			},
			_click(item, index) {
				if (this.currentValue !== index) this.currentValue = index
				this.$emit('tabClick', {item, index, id: item.id});
			},
		},
		mounted() {
			if (this.id != null) {
				this.openById(this.id)
				return
			}
			this.currentValue = this.value == null ? this.items.length > 0 ? 0 : null : this.value
		},
	}
</script>

<style lang="scss">
	@include themeify {
		.link-tabs {
			display: block;
			width: 100%;
			box-sizing: border-box;
			vertical-align: middle;
			font-size: 14px;

			$head-height: 41px;

			.link-tabs-header {
				width: 100%;
				display: flex;
				align-items: center;
				height: $head-height;
				box-sizing: border-box;
				font-size: 14px;
				background-color: white;
				padding: 0 16px;
				position: relative;

				&:after {
					position: absolute;
					bottom: 0;
					height: 1px;
					left: 0;
					right: 0;
					background-color: #F0F2F7;
					content: '';
				}

				.link-tabs-header-item {
					box-sizing: border-box;
					height: $head-height;
					line-height: $head-height;
					color: rgba(0, 0, 0, 0.65);
					cursor: pointer;
					padding: 0 16px;
					position: relative;

					.link-tabs-close {
						position: absolute;
						top: 3px;
						right: 3px;
						color: $color-error;
						display: none;
					}


					&.link-tabs-header-item-active {
						font-weight: 500;
						color: pl-var(color-primary);

						&:after {
							position: absolute;
							bottom: 0;
							height: 2px;
							left: 0;
							right: 0;
							background-color: pl-var(color-primary);
							content: '';
							z-index: 1;
						}
					}

					&:hover {
						.link-tabs-close {
							display: inline;
						}
					}

					&.link-tabs-header-item-new-button {
						min-width: 50px;
						text-align: center;

						&:hover {
							background-color: #f2f2f2;
						}

						&:active {
							background-color: #e2e2e2;
						}
					}
				}
			}

			&.link-tabs-fit-height {
				height: 100%;
				display: flex;
				flex-direction: column;

				.link-tabs-body {
					flex: 1;
					overflow: hidden;

					.link-tab {
						height: 100%;
						overflow: auto;
					}
				}
			}

			&.link-tabs-fit-height-padding{
				.link-tabs-body {
					padding-top: 16px;
				}
			}
		}

	}
</style>
